module.exports = __webpack_public_path__ + "img/ProDemos_logo_full.14483d7b.svg";